import React, { useState } from "react";
import CrudUsuariosTableRow from "./CrudUsuariosTableRow";

const CrudUsuariosTable = ({
	user,
	setUserToEdit,
	deleteUser,
	company,
	setShowForm,
}) => {
	// console.log("user:", user);
	const [filters, setFilters] = useState({
		name: "",
		email: "",
		area: "",
		type: "",
	});

	function handleSearch(e, columnName) {
		const { value } = e.target;
		setFilters((prevFilters) => ({
			...prevFilters,
			[columnName]: value.toLowerCase(),
		}));
	}

	const filteredData = user.filter((item) =>
		Object.entries(filters).every(([key, value]) =>
			String(item[key] ?? "")
				.toLowerCase()
				.includes(value.toLowerCase())
		)
	);

	// const filteredData = user.filter((item) =>
	// 	Object.entries(filters).every(([key, value]) =>
	// 		item[key].toLowerCase().includes(value)
	// 	)
	// );

	return (
		<div>
			<h3 className="titulo1">
				Lista de Usuarios de: {company} -{user.length} Usuarios-
			</h3>
			<table className="tabla-procesos">
				<thead>
					<tr className="fila-tabla-procesos">
						<th className="titleSearchColumn01">
							<label className="titulo14">Nombre</label>
							<input
								className="searchColumn"
								type="text"
								value={filters.name}
								onChange={(e) => handleSearch(e, "name")}
							/>
						</th>
						<th className="titleSearchColumn01">
							<label className="titulo14">Usuario</label>
							<input
								className="searchColumn"
								type="text"
								value={filters.email}
								onChange={(e) => handleSearch(e, "email")}
							/>
						</th>

						<th className="titleSearchColumn01">
							<label className="titulo14">Tipo</label>
							<input
								className="searchColumn"
								type="text"
								value={filters.type}
								onChange={(e) => handleSearch(e, "type")}
							/>
						</th>

						<th className="titleSearchColumn01">Acción</th>
					</tr>
				</thead>
				<tbody>
					{user.length > 0 ? (
						filteredData.map((el) => (
							<CrudUsuariosTableRow
								key={el.id}
								el={el}
								setUserToEdit={setUserToEdit}
								deleteUser={deleteUser}
								setShowForm={setShowForm}
							/>
						))
					) : (
						<tr>
							<td colSpan="3">Sin datos</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};

export default CrudUsuariosTable;
